import { Component, ViewEncapsulation, Input, inject } from '@angular/core';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { Modal, ModalType } from '@app/shared/models/modal.model';
import { SharedModule } from '@app/shared/shared.module';
import { EventManager } from '@app/shared/utils/event-manager';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-legal-layout',
  templateUrl: './legal-layout.component.html',
  styleUrls: ['./legal-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SharedModule, NavigationButtonComponent],
})
export class LegalLayoutComponent {
  @Input() modalName: string;

  private readonly eventManager = inject(EventManager);

  closeModal(): void {
    this.eventManager.closeModal(new Modal(this.modalName, ModalType.View));
  }
}
